import ContentsToReact from '@/components/ContentsToReact/ContentsToReact';
import Page from '@/components/Page/Page';
import extractPageMetaFromRouteData from '@/helpers/extractPageMetaFromRouteData';
import spliceFooterFromContentItems from '@/helpers/spliceFooterFromContentItems';
import spliceHeaderFromContentItems from '@/helpers/spliceHeaderFromContentItems';
import { useInitialPageDataLayer } from '@/hooks/useInitialPageDataLayer/useInitialPageDataLayer';
import useJobFavorites from '@/hooks/useJobFavorites/useJobFavorites';
import { PageModel } from '@/models/page';
import JobSearchPageContent from '@/uikit/components/JobSearchPageContent/JobSearchPageContent';
import Layout from '@/uikit/components/Layout/Layout';
import { LayoutVariant } from '@/uikit/components/Layout/interfaces';
import EnercityFooter from '@uikit/components/EnercityFooter/EnercityFooter';
import JobAlertModal from '@uikit/components/JobAlertModal/JobAlertModal';
import { CmsComponentsContext } from '../CmsComponentsContext';
import cmsComponents from './JobSearchPage.cmsComponents';
import type { JobSearchPageProps } from './interfaces';

const JobSearchPage = (routeData: PageModel<JobSearchPageProps>) => {
  const meta = extractPageMetaFromRouteData(routeData);
  const {
    contents,
    props: { jobs, mainCategories, timeTypes },
  } = routeData;

  const knownJobIds = jobs.map((job) => job.id);
  const {
    isFavoriteJob,
    toggleFavoriteJob,
    favoriteJobs: favorites,
  } = useJobFavorites(new Set(knownJobIds));

  const { items: contentsWithOutHeader, header } =
    spliceHeaderFromContentItems(contents);
  const headerProps = { ...header?.props, contents: header?.contents };

  const { items } = spliceFooterFromContentItems(
    contentsWithOutHeader ? contentsWithOutHeader : []
  );

  useInitialPageDataLayer();

  return (
    <CmsComponentsContext.Provider value={cmsComponents}>
      <Layout variant={LayoutVariant.Default}>
        <Page meta={meta}>
          {header && (
            <ContentsToReact
              contents={[
                {
                  ...header,
                  props: {
                    ...headerProps,
                    subHeadlineAsH1: true,
                    jobs,
                    favorites,
                  },
                },
              ]}
            />
          )}

          <JobSearchPageContent
            jobs={jobs}
            mainCategories={mainCategories}
            timeTypes={timeTypes}
            isFavoriteJob={isFavoriteJob}
            toggleFavoriteJob={toggleFavoriteJob}
          />

          {items && <ContentsToReact contents={items} />}
        </Page>
        <EnercityFooter />
      </Layout>
      <JobAlertModal />
    </CmsComponentsContext.Provider>
  );
};

export default JobSearchPage;
